const validateVINFormat = (vin) => /^[A-HJ-NPR-Z0-9]{17}$/.test(vin.trim());

const REQUIRED_FIELDS_FEES = [
  { key: "zipCode", label: "Zip Code" },
  { key: "state", label: "State" },
  { key: "city", label: "City" },
  { key: "country", label: "County" },
  { key: "basePrice", label: "Base Price" },
  { key: "plateType", label: "Plate Type" },
  { key: "transactionType", label: "Transaction Type" },
  { key: "titleStatus", label: "Title Status" },
  { key: "vinCode", label: "Vin Code" },
  { key: "vehicleType", label: "Vehicle Type" },
  { key: "fuelType", label: "Fuel Type" },
  { key: "vehicleWeight", label: "Vehicle Weight" },
  { key: "msrp", label: "MSRP" },
  { key: "modelYear", label: "Model Year" }
];

const REQUIRED_FIELDS_DOCS = [
  { key: 'zipCode', label: 'Zip Code' },
  { key: 'city', label: 'City' },
  { key: 'state', label: 'State' },
  { key: 'country', label: 'County' },
  { key: 'vinCode', label: 'VIN' },
  { key: 'vehicleType', label: 'Vehicle Type' },
  { key: 'condition', label: 'Condition' },
  { key: 'transactionType', label: 'Transaction Type' },
  { key: 'transactionDate', label: 'Transaction Date' },
  { key: 'uploadDate', label: 'Upload Date' },
];

const FormValidation = (formType = '', formData = {}) => {
  const errors = {};

  switch (formType) {
    case "Title":
      const trimmedVin = formData.vinCode?.trim();

      if (!trimmedVin) {
        errors.vinCode = 'VIN is required';
      } else if (!validateVINFormat(trimmedVin)) {
        errors.vinCode = 'Please enter a valid 17-character VIN';
      }
      break;

    case "Fees":
      REQUIRED_FIELDS_FEES.forEach(({ key, label }) => {
        if (!formData[key]) {
          errors[key] = `${label} is required`;
        }
      });
      if (!(["Purchase", "Refinance"].includes(formData["transactionType"]))) {
        errors["transactionType"] = "Transaction Type must be either Purchase or Refinance";
      }
      break;

    case "Docs":
      REQUIRED_FIELDS_DOCS.forEach(({ key, label }) => {
        if (!formData[key]) {
          errors[key] = `${label} is required`;
        }
      });
      break;

    default:
      return null;
  }

  return Object.keys(errors).length > 0 ? errors : null;
};

export default FormValidation;
